import './styles/Card.css';
export default function Card({ title, count,onclick }) {
    return (
        <div className="Card" onClick={onclick}>
            <h2>{title}</h2>
            <h3>{count}</h3>
        </div>
    )
} 